var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block container" }, [
    _c("div", { staticClass: "grid-item attention-state" }, [
      _vm.attention.status == "PENDING"
        ? _c("span", [
            _c("img", {
              staticClass: "icon icon-svg attention-state-item",
              attrs: {
                src: require("@/static/svg/icono_pendiente_v2.svg"),
                alt: "pendiente"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.attention.status == "COMPLETED"
        ? _c("span", [
            _c("img", {
              staticClass: "icon icon-svg attention-state-item",
              attrs: {
                src: require("@/static/svg/icono_check_v2.svg"),
                alt: "completado"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.attention.status == "FAILED"
        ? _c("span", [
            _c("img", {
              staticClass: "icon icon-svg attention-state-item",
              attrs: {
                src: require("@/static/svg/icono_nocheck_v2.svg"),
                alt: "fallido"
              }
            })
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-item", staticStyle: { width: "91%" } }, [
      _c("div", { staticClass: "meta-list" }, [
        _c("div", { staticClass: "meta-item date" }, [
          _c("span", { staticClass: "meta-value" }, [
            _vm._v(_vm._s(_vm._f("formatStandardDate")(_vm.attention.dueBy)))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "meta-name", staticStyle: { "margin-bottom": "3px" } },
          [
            _c("span", { staticClass: "meta-value" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.attention.responsible.name) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _vm.attentionEvaluation(_vm.attention.participationOf)
              ? _c(
                  "pill",
                  { attrs: { status: "secondary" } },
                  [
                    _c(
                      _vm.attentionEvaluation(_vm.attention.participationOf)
                        .icon,
                      { tag: "component" }
                    ),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.attentionEvaluation(_vm.attention.participationOf)
                            .text
                        ) +
                        "\n        "
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.attention.status !== "PENDING"
          ? _c("div", [
              _vm.attention.participationOf &&
              _vm.attention.participationOf.comment.comment
                ? _c("div", { staticClass: "meta-item comment" }, [
                    _c("span", { staticClass: "meta-value" }, [
                      _vm._v(
                        _vm._s(_vm.attention.participationOf.comment.comment)
                      )
                    ])
                  ])
                : _c("div", { staticClass: "comment" }, [
                    _c("span", { staticClass: "meta-value" }, [
                      _vm._v("Sin Comentario")
                    ])
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "meta-item registerBy" }, [
          _c("span", [
            _vm._v(
              "\n          Registrado: " +
                _vm._s(_vm._f("formatStandardDate")(_vm.attention.createdAt)) +
                ",\n          " +
                _vm._s(_vm.attention.creator.name) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.attention.status !== "PENDING" && _vm.attention.finishedBy
          ? _c("div", [
              _c("span", { staticClass: "meta-item close-responsible" }, [
                _vm._v("Responsable: " + _vm._s(_vm.attention.finishedBy.name))
              ])
            ])
          : _c("div", [
              _c("span", { staticClass: "meta-item close-responsible" }, [
                _vm._v("Sin responsable de cierre")
              ])
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "attentions-buttons" }, [
          !_vm.attention.isDone
            ? _c("div", { staticClass: "actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary",
                    staticStyle: {
                      margin: "17px 17px 17px 0",
                      "text-decoration": "none"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.finishAttention(_vm.attention.id)
                      }
                    }
                  },
                  [_vm._v("Finalizar")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.canDeleteAttention()
            ? _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "button is-danger",
                    staticStyle: {
                      margin: "17px 0",
                      "text-decoration": "none"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.deleteAttention(_vm.attention.id)
                      }
                    }
                  },
                  [_vm._v("Eliminar")]
                )
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }